import React from 'react'

export default function Footer() {
    return (
        <>
            <footer className="main-footer">
                {/* <strong>Copyright &copy; 2021 <a href="https://kurdishtalent.com" target="_blank">KurdishTalent.com</a>.</strong>
            Copyright 2014 - 2024 - Kurdishtalent - All Rights Reserved
                All rights reserved. */}
                &nbsp;
                <div className="float-right d-none d-sm-inline-block">
                &nbsp; {/* <b>Version</b> 1.1.0 */}
                </div>
            </footer>
            <aside className="control-sidebar control-sidebar-dark">

            </aside>
        </>
    )
}
